import "./App.css";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import MainWindow from "./mainLayer/MainWindow";
import Login from "./login/Login";
import { ThemeProvider, useTheme } from "./theme/ThemeContext";
import { LayoutProvider } from "./layout/LayoutContext";
import { MenuSelectProvider } from "./roundMenuContext/roundMenuContext";
import { EWSProvider } from "./provider/EWSProvider";
import { HzProvider } from "./provider/HzProvider";
import { AllWeatherProvider } from "./provider/AllWeatherProvider";
import { RiverProvider } from "./provider/RiverProvider";
import { AirQualityProvider } from "./provider/AirQualityProvider";
import { RainfallProvider } from "./provider/RainfallProvider";
import { SatelightProvider } from "./provider/SatelightProvider";
import { MapLayersProvider } from "./provider/MapLayers";


interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token = localStorage.getItem("accessToken");
  const username = localStorage.getItem("username");

  return token && username ? children : <Navigate to="/" />;
};

function App() {
  return (

    <ThemeProvider>
      <LayoutProvider>
        <MenuSelectProvider>
          <MapLayersProvider>
        <EWSProvider>  
          <HzProvider>
          <RiverProvider>
          <AirQualityProvider>
          <RainfallProvider>
          <SatelightProvider>
            <AllWeatherProvider>
          <div className="App">
            <Routes>
              <Route path="/" element={<Login />} />
              <Route
                path="/eagle-I"
                element={
                  <ProtectedRoute>
                    <MainWindow />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
          </AllWeatherProvider>
         </SatelightProvider>
          </RainfallProvider>
          </AirQualityProvider>
          </RiverProvider>
          </HzProvider>
          </EWSProvider>
          </MapLayersProvider>
        </MenuSelectProvider>
      </LayoutProvider>
    </ThemeProvider>
 
  );
}

export default App;
